import React from 'react';
import { useTranslation } from 'react-i18next';
import { Phone, Mail, MessageCircle } from 'lucide-react';

const HelpPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden p-8">
        <div className="text-center mb-10 border-b pb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">{t('helpPage.title')}</h1>
          <p className="text-lg text-gray-600">{t('helpPage.subtitle')}</p>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('helpPage.search.title')}</h2>
            <p className="mb-4">{t('helpPage.search.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('helpPage.account.title')}</h2>
            <p className="mb-4">{t('helpPage.account.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('helpPage.tours.title')}</h2>
            <p className="mb-4">{t('helpPage.tours.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('helpPage.contactSupport.title')}</h2>
            <p className="mb-4">{t('helpPage.contactSupport.content')}</p>
            <div className="bg-gray-50 p-6 rounded-lg space-y-3">
              <div className="flex items-center">
                <Phone className="h-5 w-5 mr-3 text-blue-600" />
                <a href="tel:+595972350400" className="hover:underline">{t('helpPage.contactSupport.phone')}</a>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 mr-3 text-blue-600" />
                <a href="mailto:info@realtypy.com" className="hover:underline">{t('helpPage.contactSupport.email')}</a>
              </div>
              <div className="flex items-center">
                <MessageCircle className="h-5 w-5 mr-3 text-green-600" />
                <a href="https://wa.me/595972350400" target="_blank" rel="noopener noreferrer" className="hover:underline">{t('helpPage.contactSupport.whatsapp')}</a>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('helpPage.languages.title')}</h2>
            <p className="mb-4">{t('helpPage.languages.content')}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
